export default __webpack_public_path__ + "static/media/bariyelic2.caf89bb0.jpg";